export const LINK_ACCESS_DENIED = '/403';
export const LINK_SIGN_IN = '/sign-in';
export const LINK_FORGOT_PASSWORD = '/forgot-password';
export const LINK_RECOVERY_TOKEN = '/recovery-token';
export const LINK_START = '/start';
export const LINK_START_STEP = '/start/step';
export const LINK_START_VERIFICATION = '/start/verification';
export const LINK_START_FIRST = LINK_START_STEP + '/1';
export const LINK_START_LAST = LINK_START_STEP + '/6';
export const LINK_BLOCKED = '/blocked';
export const LINK_RESET_SECURITY_VERIFICATION = '/reset-security-verification';
export const LINK_SECURITY_VERIFICATION = '/security-verification';

export const LINK_ADMIN = '/admin';
export const LINK_ADMIN_RETAILERS = '/admin/retailers';
export const LINK_ADMIN_RETAILER_DETAILS = '/admin/retailers/details';
export const LINK_ADMIN_TRANSACTIONS = '/admin/transactions';
export const LINK_ADMIN_TRANSACTIONS_DETAILS = '/admin/transactions/details';

export const LINK_DASHBOARD = '/dashboard';
export const LINK_INVOICE = '/dashboard/invoice';
export const LINK_TRANSACTIONS = '/transactions';
export const LINK_TRANSACTION_DETAILS = '/transactions/details';
export const LINK_DEVELOPER_OPTIONS = '/developer-options';
export const LINK_CREATE_APP = '/developer-options/create';
export const LINK_EDIT_APP = '/developer-options/edit';
export const LINK_APP = '/developer-options/details';
export const LINK_CRYPTO_WALLETS = '/crypto-wallets/';
export const LINK_CREATE_CRYPTO_WALLET = '/crypto-wallets/create';
export const LINK_EDIT_CRYPTO_WALLET = '/crypto-wallets/edit';

export const LINK_PAYMENT_LINK = '/payment-link';

export const LINK_MANAGEMENT = '/management';
export const LINK_WITHDRAWAL_ACCOUNTS = LINK_MANAGEMENT;
export const LINK_BANK_ACCOUNT_CREATE = `${LINK_WITHDRAWAL_ACCOUNTS}?id=create`;

export const LINK_SETTINGS = '/settings';
export const LINK_HELP = '/help';
